(function () {
  const HEADING_SELECTOR = 'h2, h3, h4, h5, h6';

  function initBlogArticleToc(root) {
    const toc = root.querySelector('[data-blog-article-toc]');
    if (!toc) return;

    const toggle = toc.querySelector('[data-blog-article-toc-toggle]');
    const panel = toc.querySelector('[data-blog-article-toc-panel]');
    const mobileMq = window.matchMedia('(max-width: 767px)');

    const isMobileToc = () => mobileMq.matches;

    const setTocOpen = (open) => {
      if (!toggle || !panel) return;
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      panel.hidden = !open;
      toc.classList.toggle('is-open', open);
    };

    if (toggle && panel) {
      setTocOpen(!isMobileToc());

      toggle.addEventListener('click', () => {
        if (!isMobileToc()) return;
        setTocOpen(toggle.getAttribute('aria-expanded') !== 'true');
      });

      mobileMq.addEventListener('change', () => {
        setTocOpen(!isMobileToc());
      });
    }

    const links = Array.from(toc.querySelectorAll('.blog-article__toc-link'));
    if (!links.length) return;

    const ids = links
      .map((a) => {
        const href = a.getAttribute('href');
        return href && href.startsWith('#') ? href.slice(1) : null;
      })
      .filter(Boolean);

    const anchors = ids
      .map((id) => document.getElementById(id))
      .filter((el) => el instanceof HTMLElement);

    if (!anchors.length) return;

    const scrollOffset = () => {
      const pad = isMobileToc() ? 8 : 16;
      const sticky = document.querySelector('sticky-header');

      if (sticky) {
        const h = sticky.getBoundingClientRect().height;
        if (h > 0) return Math.round(h) + pad;
      }

      const css = getComputedStyle(document.documentElement);
      const n = parseInt(css.getPropertyValue('--sticky-header-height'), 10);

      if (Number.isFinite(n) && n > 0) return n + pad;

      return isMobileToc() ? 64 : 96;
    };

    /** First heading after the anchor — real start of the section in the article body */
    const getSectionStart = (anchor) => {
      let node = anchor.nextElementSibling;

      while (node) {
        if (node.classList && node.classList.contains('blog-article__toc-anchor')) break;
        if (node.matches && node.matches(HEADING_SELECTOR)) return node;
        if (node.querySelector) {
          const heading = node.querySelector(HEADING_SELECTOR);
          if (heading) return heading;
        }
        node = node.nextElementSibling;
      }

      return anchor;
    };

    const sectionTop = (anchor) => getSectionStart(anchor).getBoundingClientRect().top;

    let lockedActiveId = null;
    let scrollEndTimer = null;

    const releaseScrollLock = () => {
      lockedActiveId = null;
      pickActiveFromScroll();
    };

    const setActive = (id) => {
      links.forEach((link) => {
        const href = link.getAttribute('href');
        const match = href === `#${id}`;
        link.classList.toggle('is-active', match);
        if (match) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      });
    };

    const pickActiveFromScroll = () => {
      if (lockedActiveId) {
        setActive(lockedActiveId);
        return;
      }

      const offset = scrollOffset();
      let current = ids[0];
      let matched = false;

      for (let i = 0; i < anchors.length; i++) {
        const top = sectionTop(anchors[i]);
        const nextTop = i + 1 < anchors.length ? sectionTop(anchors[i + 1]) : Infinity;

        if (top <= offset && nextTop > offset) {
          current = anchors[i].id;
          matched = true;
          break;
        }
      }

      if (!matched) {
        const last = anchors[anchors.length - 1];
        if (sectionTop(last) <= offset) {
          current = last.id;
        }
      }

      setActive(current);
    };

    const scrollToSection = (anchor, behavior) => {
      const target = getSectionStart(anchor);
      const clickExtra = isMobileToc() ? 260 : -20;
      const y =
        target.getBoundingClientRect().top +
        window.scrollY -
        scrollOffset() -
        clickExtra;

      window.scrollTo({ top: Math.max(0, y), behavior: behavior || 'smooth' });
    };

    links.forEach((link) => {
      link.addEventListener('click', (e) => {
        const href = link.getAttribute('href');
        if (!href || href.charAt(0) !== '#') return;
        e.preventDefault();

        const anchor = document.getElementById(href.slice(1));
        if (!anchor) return;

        lockedActiveId = anchor.id;
        setActive(anchor.id);
        scrollToSection(anchor, 'smooth');
        history.replaceState(null, '', href);

        clearTimeout(scrollEndTimer);
        scrollEndTimer = setTimeout(releaseScrollLock, 1000);

        if (isMobileToc()) {
          setTocOpen(false);
        }
      });
    });

    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        if (lockedActiveId) {
          setActive(lockedActiveId);
        } else {
          pickActiveFromScroll();
        }
        ticking = false;
      });
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });

    if ('onscrollend' in window) {
      window.addEventListener(
        'scrollend',
        () => {
          if (lockedActiveId) releaseScrollLock();
        },
        { passive: true }
      );
    }

    pickActiveFromScroll();
  }

  document.querySelectorAll('.blog-article[data-blog-article-root]').forEach(initBlogArticleToc);
})();
